import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

interface Category {
  id: string;
  name: string;
}

const AddSubCategory = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [formData, setFormData] = useState({
    category: "",
    name: "",
    slug: "",
    description: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
  });
  const [loading, setLoading] = useState(true);

  // ✅ Base URL from environment (.env)
  const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:4000/api/v1";

  // Fetch main categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/category`);
        setCategories(res.data || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
        alert("Failed to fetch categories!");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [API_BASE_URL]);

  // Handle form changes
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    let updatedValue = value;

    // Auto-generate slug when typing the name
    if (name === "name") {
      const slug = value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase()
        .replace(/&/g, "-and-")
        .replace(/[^a-z0-9\-]/g, "")
        .replace(/-+/g, "-")
        .replace(/^-*/, "")
        .replace(/-*$/, "");
      setFormData((prev) => ({ ...prev, name: updatedValue, slug }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
  };

  // Handle submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      await axios.post(`${API_BASE_URL}/subcategory`, formData);
      alert("✅ Subcategory added successfully!");
      navigate("/settings/subcategory");
    } catch (err) {
      console.error("Error adding subcategory:", err);
      alert("❌ Failed to add subcategory!");
    }
  };

  if (loading) return <div className="p-5 text-center">Loading...</div>;

  return (
    <div className="main-container container-fluid">
      {/* PAGE HEADER */}
      <div className="page-header">
        <h1 className="page-title">Add Sub Category</h1>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          <li className="breadcrumb-item active">Sub Category</li>
        </ol>
      </div>

      <div className="row">
        <div className="col-xl-12 col-md-12">
          <form className="card" onSubmit={handleSubmit}>
            <div className="card-body">
              {/* Select Category */}
              <div className="form-group">
                <label className="form-label">Select Category</label>
                <select
                  className="form-select"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Sub Category Name */}
              <div className="form-group">
                <label className="form-label">Sub Category Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Slug URL */}
              <div className="form-group">
                <label className="form-label">Slug URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="slug"
                  value={formData.slug}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Description */}
              <div className="form-group">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>

              {/* Meta Title */}
              <div className="form-group">
                <label className="form-label">Meta Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="meta_title"
                  value={formData.meta_title}
                  onChange={handleChange}
                />
              </div>

              {/* Meta Description */}
              <div className="form-group">
                <label className="form-label">Meta Description</label>
                <textarea
                  className="form-control"
                  name="meta_description"
                  value={formData.meta_description}
                  onChange={handleChange}
                />
              </div>

              {/* Meta Keywords */}
              <div className="form-group">
                <label className="form-label">Meta Keywords</label>
                <textarea
                  className="form-control"
                  name="meta_keywords"
                  value={formData.meta_keywords}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddSubCategory;

